// extracted by mini-css-extract-plugin
export default {"page":"page-Bz47R","tab":"tab-mfWJc","active":"active-K8ujT"};